const DEV_ENDPOINT =
  process.env.REACT_APP_CUSTOMER_AREA_URL
    || (process.env.NODE_ENV === 'development'
      ? 'https://api.appscience.pro/customer-area'
      : 'http://localhost:8080')

const dev = {
  API_ENDPOINT_URL: DEV_ENDPOINT,
}

const prod = {
  // api.conc.ru проксит на api.appscience.pro (сам .pro закрыт от браузера)
  API_ENDPOINT_URL: 'https://api.conc.ru/customer-area',
}

const test = {
  API_ENDPOINT_URL: 'https://api.test.com',
}

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case 'development':
      return dev
    case 'production':
      return prod
    case 'test':
      return test
    default:
      break
  }
}

export const env = getEnv()
